import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  search(params: any): Observable<any> {
    let httpParams = new HttpParams()
      .set('query', params.query || '')
      .set('category', params.category)
      .set('page', params.page.toString())
      .set('pageSize', params.pageSize.toString());

    if (params.startDate) {
      httpParams = httpParams.set('startDate', params.startDate);
    }

    if (params.endDate) {
      httpParams = httpParams.set('endDate', params.endDate);
    }

    if (params.status) {
      httpParams = httpParams.set('status', params.status);
    }

    return this.http.get<any>(`${this.apiUrl}/search`, { params: httpParams });
  }

  downloadPdf(category: string, id: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/${category}/${id}/pdf`, { 
      responseType: 'blob' 
    });
  }
}